package com.fireavert.yardi.common_data.data_models.responses

import com.fireavert.yardi.common_data.data_models.RateLimitInfo
import kotlinx.serialization.Serializable

@Serializable
data class YardiCommonDataGetRateLimitResponse(
    val response: List<RateLimitInfo>,
)